import React from 'react';
import { Row, Col } from 'reactstrap';

const FinancialTab = () => {
  return (
    <Row>
      <Col md={12}>
        <div className="text-center p-4">
          <h5>Financial</h5>
          <p className="text-muted">Account financial information will be implemented here.</p>
        </div>
      </Col>
    </Row>
  );
};

export default FinancialTab; 